// @ts-ignore
export default defineAppConfig({
  notifications: {
    position: "top-0 bottom-[unset]",
  },
  ui: {
    primary: "green",
    gray: "cool",
    content: {
      prose: {
        code: {
          icon: {
            curl: "i-simple-icons-curl",
          },
        },
      },
    },
    button: {
      default: {
        size: "md",
      },
    },
    input: {
      default: {
        size: "md",
      },
    },
    card: {
      rounded: "rounded-xl",
    },
    footer: {
      top: {
        wrapper: "border-t border-gray-200 dark:border-gray-800",
        container: "py-8 lg:py-16",
      },
      bottom: {
        wrapper: "border-t border-gray-200 dark:border-gray-800",
      },
    },
    page: {
      hero: {
        wrapper: "lg:py-24",
      },
    },
  },
});

const defaultColors = ["green", "teal", "cyan", "sky", "blue", "indigo", "violet"];
